import { FormattedMessage } from 'react-intl';

import type { FiltersGroup } from '@sorare/core/src/lib/filters';
import { filters } from '@sorare/core/src/lib/glossary';

import {
  BackendRefineMarketValues,
  RefineMarketValues,
} from '#src/searchCommonPlayer/RangeSlider/index.tsx';

export const MarketValuesGroup: FiltersGroup = {
  slug: 'market_value',
  title: <FormattedMessage {...filters.marketValues} />,
  filters: RefineMarketValues(true),
};

export const BackendMarketValuesGroup: FiltersGroup = {
  slug: 'market_value',
  title: <FormattedMessage {...filters.marketValues} />,
  filters: BackendRefineMarketValues(true),
};
